import router from '@/router'
import axios from 'axios'
import { config, url } from '@/store'

const tabs = [
  { name: 'Созданные', count: 0, id: 1, value: 'IsCraeted' },
  { name: 'На согласовании', count: 0, id: 2, value: 'IsReconciliation' },
  { name: 'На контроль', count: 0, id: 3, value: 'IsControl' },
  { name: 'Закрытые', count: 0, id: 4, value: 'Isclosed' }
]

const state = () => ({
  tableHeaders: {
    allActive: false,
    headers: [
      {
        title: 'Создано',
        isSortable: true,
        sortName: 'created_at',
        dispatchName: '[approve] getApproveSort'
      },
      {
        title: 'Изменено',
        isSortable: true,
        sortName: 'updated_at',
        dispatchName: '[approve] getApproveSort'
      },
      {
        title: 'Название',
        isSortable: false,
        sortName: 'name'
      },
      {
        title: 'Конечная дата',
        isSortable: true,
        sortName: 'expiration_date',
        dispatchName: '[approve] getApproveSort'
      },
      {
        title: 'Статус',
        isSortable: true,
        sortName: 'expiration_date',
        dispatchName: '[approve] getApproveSort'
      },
      {
        title: 'Документ',
        isSortable: false,
        sortName: 'document_id'
      },
      {
        title: 'Согласование по порядку',
        isSortable: true,
        sortName: 'in_order',
        dispatchName: '[approve] getApproveSort'
      },
      {
        title: 'Создал',
        isSortable: false,
        sortName: 'user.surname'
      }
    ]
  },
  approves: [
    // {
    //   id: 1,
    //   isControlsActive: false,
    //   isActive: false,
    //   status: '',
    //   name: '',
    //   create_date: '',
    //   update_date: '',
    //   expiration_date: '',
    //   document_id: '',
    //   in_order: '',
    //   creator: ''
    // }
  ],
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  searchValue: '',
  filter: {},
  sort: {},
  isLoading: true,
  activeTabIndex: 0,
  responseModal: {
    isActive: false,
    title: '',
    text: '',
    type: ''
  },
  responseModalWithTreaties: {
    isActive: false,
    title: 'Ошибка!',
    text: '',
    type: 'main'
  },
  statusApproveList: [
    { id: 1, name: 'ПРОСРОЧЕН' },
    { id: 2, name: 'Срок истекает' }
  ],
  isActiveDelete: false,
  tabsFilter: tabs,
  tabLoading: false,
  filterIsActive: false
})

const getters = {
  '[approve] getApproveStatusList': state => state.statusApproveList,
  '[approve] getApproveList': state => state.approves,
  '[approve] getApproveListTabsFilter': state => state.tabsFilter,
  '[approve] getApproveListPagination': state => state.pagination,
  '[approve] getApproveListSearchValue': state => state.searchValue,
  '[approve] getApproveListTableHeaders': state => state.tableHeaders,
  '[approve] getApproveListIsActiveDelete': state => state.isActiveDelete,
  '[approve] getApproveListIsLoading': state => state.isLoading,
  '[approve] getApproveListFilter': state => state.filter,
  '[approve] getActiveTabIndex': state => state.activeTabIndex,
  '[approve] getTabLoading': state => state.tabLoading,
  '[approve] getFilterIsActive': state => state.filterIsActive
}

const mutations = {
  '[approve] SET_TAB_LOADING': (state) => {
    state.tabLoading = !state.tabLoading
  },
  '[approve] GET_APPROVE_LIST': (state, approves) => {
    state.approves = approves.map(approve => {
      return {
        ...approve,
        isControlsActive: false,
        isActive: false
      }
    })
  },

  '[approve] TOGGLE_APPROVE_LIST_ITEM_CONTROLS': (state, itemId) => {
    state.approves.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isControlsActive = !elem.isControlsActive
      } else if (itemId !== elem.id) {
        elem.isControlsActive = false
      }
    })
  },

  '[approve] SET_APPROVE_TABS_ACTIVE_INDEX': (state, index) => {
    state.activeTabIndex = index
  },

  '[approve] SET_APPROVE_LIST_TABS_COUNT': (state, countInfo) => {
    state.tabsFilter = state.tabsFilter.map(tab => {
      switch (tab.value) {
        case 'IsCraeted':
          tab.count = countInfo.created
          break
        case 'IsReconciliation':
          tab.count = countInfo.reconciliation
          break
        case 'IsControl':
          tab.count = countInfo.control
          break
        case 'Isclosed':
          tab.count = countInfo.closed
          break
      }
      return tab
    })
  },

  // tabsFilter
  '[approve] SET_APPROVE_LIST_TABS_ACTIVE_INDEX': (state, index) => {
    state.activeTabIndex = index
  },

  '[approve] TOGGLE_APPROVE_LIST_ITEM_ACTIVE': (state, itemId) => {
    const itemsLength = state.approves.length
    let counter = 0

    state.approves.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0 ? state.isActiveDelete = true : state.isActiveDelete = false

    state.tableHeaders.allActive = counter === itemsLength
  },
  '[approve] TOGGLE_APPROVE_LIST_ITEM_ACTIVE_ALL': (state) => {
    state.tableHeaders.allActive = !state.tableHeaders.allActive
    state.tableHeaders.allActive ? state.isActiveDelete = true : state.isActiveDelete = false

    state.approves.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },
  '[approve] RESET_APPROVES_LIST_ALL_CHECKS': (state) => {
    state.tableHeaders.allActive = false
    state.isActiveDelete = false
    state.approves.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },

  // filter
  '[approve] SET_APPROVE_LIST_FILTER': (state, filter) => {
    state.filter = filter
  },

  '[approve] SET_APPROVE_LIST_FILTER_ACTIVE': (state, isActive) => {
    state.filterIsActive = isActive
  },

  // delete checked items
  '[approve] DELETE_APPROVES_LIST_CHECKED_ITEMS_SUCCESS': (state) => {
    state.responseModal.isActive = true
    state.responseModal.title = 'Успех!'
    state.responseModal.text = 'Вы успешно удалили заказ(ы)'
    state.responseModal.type = 'main'
  },
  '[approve] DELETE_APPROVES_LIST_CHECKED_ITEMS_ERROR': (state, errorItems) => {
    let listNamesErrorItems
    errorItems.forEach(e => {
      listNamesErrorItems = listNamesErrorItems + ` ${e.short_name}`
    })
    state.responseModal.isActive = true
    state.responseModal.title = 'Ошибка!'
    state.responseModal.text = `При удалении заказа произошла ошибка:${listNamesErrorItems}`
    state.responseModal.type = 'main'
  },

  // sort
  '[approve] SET_APPROVE_SORT': (state, sortOptions) => {
    state.sort = sortOptions
  },

  // pagination
  '[approve] SET_APPROVE_LIST_PAGINATION': (state, headers) => {
    state.pagination.currentPage = Number(headers['x-pagination-current-page'])
    state.pagination.lastPage = Number(headers['x-pagination-page-count'])
    state.pagination.currentTage = Number(headers['x-pagination-per-page'])
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
  },
  '[approve] SET_CURRENT_PAGE': (state, pageNum) => {
    state.pagination.currentPage = pageNum
  },
  '[approve] RESET_APPROVE_LIST_CURRENT_PAGE': (state) => {
    state.pagination.currentPage = 1
  },

  // search
  '[approve] SET_APPROVE_LIST_SEARCH_VALUE': (state, searchValue) => {
    state.searchValue = searchValue
  },
  '[approve] SET_APPROVE_LIST_LOADING': (state, payload) => {
    state.isLoading = payload
  },

  // reset store
  '[approve] RESET_APPROVE_LIST_STORE': (state) => {
    // state.searchValue = ''
    state.sort = {}
    // state.filter = {}
    state.isActiveDelete = false
    state.tableHeaders.allActive = false
    state.pagination.currentPage = 1
  }
}

const actions = {
  '[approve] getApproveList' ({ commit, rootState, state }) {
    let type
    switch (router.history.current.name) {
      case 'ApproveList_new':
        type = 'created'
        break
      case 'ApproveList_reconciliation':
        type = 'reconciliation'
        break
      case 'ApproveList_control':
        type = 'control'
        break
      case 'ApproveList_closed':
        type = 'closed'
        break
    }

    const params = {
      type: type,
      expand: 'user,treaty,files',
      sort: (state.sort.descending ? '-' : '') + (state.sort.name || 'id'),
      take: state.pagination.currentTake,
      page: state.pagination.currentPage,
      user_id: rootState.appData.currentUser.id,
      'search[all]': state.searchValue ? `${state.searchValue}` : ''
    }

    const filter = {
      name: state.filter.approveName,
      status: state.filter.status?.id,
      created_at: state.filter.createDate,
      updated_at: state.filter.updateDate,
      expiration_date: state.filter.endDate,
      document_id: state.filter.treaties?.id,
      user_id: state.filter.createBy,
      in_order: state.filter.in_order ? 'true' : 'false'
    }

    for (const key in filter) {
      if (filter[key]) {
        params[`search[${key}]`] = filter[key]
      }
    }

    commit('[approve] SET_APPROVE_LIST_LOADING', true)
    commit('[approve] SET_TAB_LOADING')
    axios.get(`${url}/approve`, { params, ...config }).then(response => {
      const countInfo = response.data.data.at(-1)
      const list = response.data.data.slice(0, -1)

      commit('[approve] SET_APPROVE_LIST_TABS_COUNT', countInfo)
      commit('[approve] GET_APPROVE_LIST', list)
      commit('[approve] SET_APPROVE_LIST_PAGINATION', response.headers)
    }).catch(error => {
      console.log('ошибка получения списка листов', error)
    }).finally(() => {
      commit('[approve] SET_TAB_LOADING')
      state.isLoading = false
    })
  },

  '[approve] getApproveListPage' ({ commit, dispatch }, pageNum) {
    commit('[approve] SET_CURRENT_PAGE', pageNum)
    dispatch('[approve] getApproveList')
  },

  '[approve] removeApproveListItem' ({ state, dispatch }, itemId) {
    axios.delete(`${url}/approve/${itemId}`, config).then(response => {
      dispatch('[approve] getApproveList')
    }).catch(error => {
      console.log('Ошибка удаления', error.response)
    })
  },

  // delete checked items
  '[approve] deleteApproveListCheckedItems' ({ commit, state, dispatch }) {
    const checkedItems = []
    const errorItems = []
    state.approves.forEach((e) => {
      if (e.isActive) {
        checkedItems.push(e)
      }
    })

    async function processMessages (array) {
      for (const item of array) {
        await axios.delete(`${url}/approve/${item.id}`, config).then((response) => {
        }).catch(error => {
          errorItems.push(item)
          console.log('Ошибка удаления', error)
        })
      }
    }
    processMessages(checkedItems).then(() => {
      if (errorItems.length > 0) {
        commit('[approve] RESET_APPROVES_LIST_ALL_CHECKS')
        commit('[approve] DELETE_APPROVES_LIST_CHECKED_ITEMS_ERROR', errorItems)
        dispatch('[approve] getApproveList')
      } else {
        commit('[approve] RESET_APPROVES_LIST_ALL_CHECKS')
        commit('[approve] DELETE_APPROVES_LIST_CHECKED_ITEMS_SUCCESS')
        dispatch('[approve] getApproveList')
      }
    })
  },

  '[approve] setApproveListSearchValue' ({ commit, dispatch }, searchValue) {
    commit('[approve] SET_APPROVE_LIST_SEARCH_VALUE', searchValue)
    commit('[approve] RESET_APPROVE_LIST_CURRENT_PAGE')
    dispatch('[approve] getApproveList')
  },

  // sort
  '[approve] getApproveSort' ({ commit, dispatch }, sort) {
    commit('[approve] SET_APPROVE_SORT', sort)
    dispatch('[approve] getApproveList')
  },

  // tabsFilter
  '[approve] setApproveListActiveTabs' ({ commit, dispatch }, index) {
    commit('[approve] SET_APPROVE_TABS_ACTIVE_INDEX', index)
    dispatch('[approve] getApproveList')
  }

}

export default {
  state,
  getters,
  mutations,
  actions
}
